import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the top of the page on every route change.
 *
 * Prefers Lenis's programmatic `scrollTo` (exposed via `window.__lenis`)
 * for a smooth animated scroll; falls back to a native instant scroll
 * when Lenis isn't available (reduced-motion users, SSR, initial mount
 * before Lenis has initialized).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      const anchor = hash === '#tickets' ? document.getElementById('tickets') : null;
      const lenis = typeof window !== 'undefined' ? window.__lenis : null;

      if (lenis && typeof lenis.scrollTo === 'function') {
        lenis.scrollTo(anchor || 0, { immediate: true, offset: anchor ? -96 : 0 });
      } else if (typeof window !== 'undefined') {
        if (anchor) anchor.scrollIntoView();
        else window.scrollTo(0, 0);
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
